<div class="container" [class.recording]="active">

  @if(!active && !disabled) {
    <svg
      class="circle-ripple"
      [attr.height]="size"
      [attr.width]="size"
    ></svg>
  }


  <svg
    class="ring ring-background"
    aria-hidden="true"
    [attr.height]="size"
    [attr.width]="size"
  >
    <circle
      fill="black"
      [attr.r]="radius"
      [attr.cx]="halfsize"
      [attr.cy]="halfsize"
    />
    <circle
      fill="transparent"
      [attr.stroke-width]="strokeWidth"
      [attr.r]="radius"
      [attr.cx]="halfsize"
      [attr.cy]="halfsize"
    />
  </svg>

  <svg
    class="ring ring-progress"
    aria-hidden="true"
    [attr.height]="size"
    [attr.width]="size"
  >
    <circle
      fill="transparent"
      [attr.stroke-width]="strokeWidth"
      [attr.stroke-dasharray]="strokeDasharray"
      [attr.stroke-dashoffset]="offset"
      [attr.r]="radius"
      [attr.cx]="halfsize"
      [attr.cy]="halfsize"
    />
  </svg>

  <button
    #button
    aria-label="Record"
    [class.active]="active"
    [disabled]="disabled"
    (touchstart)="onClick($event)"
    (click)="onClick($event)"
    oncontextmenu="return false;"
  >
    @if (active) {
      <div class="stop"></div>
    } @else {
      <div class="dot"></div>
    }
  </button>
</div>
